import React from 'react';
import { Link } from 'react-router-dom';

const VideoPage = () => {
  return (
    <main data-testid="video-page" className="pt-24 pb-16">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Video Promo</p>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4">
            Chi si occupa di loro?
          </h1>
          <p className="text-xl text-[#00FF41] font-bold">Lo faremo noi.</p>
        </div>

        {/* Spot Colle Val d'Elsa - YouTube Embed */}
        <div className="mb-16">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4 text-center">Colle Val d'Elsa — La nostra città</p>
          <div className="bg-black border border-white/10 overflow-hidden">
            <div className="relative w-full" style={{paddingBottom: '56.25%'}}>
              <iframe 
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/V7EWjXK8Lak?rel=0&modestbranding=1"
                title="Colle Val d'Elsa - Spot"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                data-testid="youtube-colle-embed"
              />
            </div>
          </div>
          <p className="text-zinc-500 text-sm text-center mt-3">Questa è la città dove nasce AI_COVO. Questa è la bellezza che vogliamo proteggere.</p>
        </div>

        {/* Video Promo - Coming Soon */}
        <div className="mb-16">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-8 text-center">I nostri Video Promo — In lavorazione</p>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-[#0A0A0A] border border-blue-500/30 p-8 text-center">
              <p className="text-4xl mb-4">🧒</p>
              <h3 className="text-xl font-bold text-white mb-2">Per i Giovani</h3>
              <p className="text-zinc-500 text-sm mb-4">Connessi ma sconnessi. Un ragazzo chiuso in camera mentre fuori c'è tutta la bellezza di Colle.</p>
              <p className="text-blue-400 font-mono text-xs">COMING SOON</p>
            </div>
            <div className="bg-[#0A0A0A] border border-amber-500/30 p-8 text-center">
              <p className="text-4xl mb-4">👴</p>
              <h3 className="text-xl font-bold text-white mb-2">Per gli Anziani</h3>
              <p className="text-zinc-500 text-sm mb-4">Sai fare lo SPID? Nell'AI_COVO nessuno resta indietro.</p>
              <p className="text-amber-400 font-mono text-xs">COMING SOON</p>
            </div>
            <div className="bg-[#0A0A0A] border border-purple-500/30 p-8 text-center">
              <p className="text-4xl mb-4">🌍</p>
              <h3 className="text-xl font-bold text-white mb-2">Per gli Immigrati</h3>
              <p className="text-zinc-500 text-sm mb-4">Puoi restare in piazza oppure imparare l'italiano, l'inglese, il cinese.</p>
              <p className="text-purple-400 font-mono text-xs">COMING SOON</p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-8 text-center">
          <p className="text-xl text-white mb-2">
            "Non hanno più qualcuno che crede in loro."
          </p>
          <p className="text-2xl font-bold text-[#00FF41] mb-6">
            Lo faremo noi di AI_COVO.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/dona" className="btn-primary bg-[#00FF41] text-black border-[#00FF41]">
              Sostieni - 19€
            </Link>
            <Link to="/pitch" className="btn-primary">
              Vedi il Pitch
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default VideoPage;
